import { render, staticRenderFns } from "./TransportCostsForm.vue?vue&type=template&id=7587cbe4&"
import script from "./TransportCostsForm.vue?vue&type=script&lang=ts&"
export * from "./TransportCostsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports